import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

function MonthCard({ year, month, report, onClick }) {
  const monthName = MONTHS[month - 1];
  const hasData = !!report;
  return (
    <div
      onClick={() => onClick(year, month)}
      style={{
        background: hasData ? '#f0faf0' : '#fafafa',
        border: `1.5px solid ${hasData ? '#4caf50' : '#e0e0e0'}`,
        borderRadius: 10,
        padding: '20px 18px',
        cursor: 'pointer',
        transition: 'box-shadow 0.15s, transform 0.1s',
        position: 'relative',
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 18px rgba(46,125,50,0.13)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}
    >
      <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>{year}</div>
      <div style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', marginBottom: 8 }}>{monthName}</div>
      {hasData ? (
        <>
          <div style={{ fontSize: 12, color: '#4caf50', fontWeight: 600, marginBottom: 2 }}>
            Report exists
          </div>
          {report.name && <div style={{ fontSize: 12, color: '#666' }}>{report.name}</div>}
          <div style={{
            position: 'absolute', top: 12, right: 12,
            width: 8, height: 8, borderRadius: '50%', background: '#4caf50',
          }} />
        </>
      ) : (
        <div style={{ fontSize: 12, color: '#bbb' }}>Click to create</div>
      )}
    </div>
  );
}

export default function ExpenseList() {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const now = new Date();
  const currentYear = now.getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  useEffect(() => {
    axios.get('/api/expenses/reports/', {
      headers: { Authorization: `Token ${token}` },
    })
      .then(r => setReports(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  const reportMap = {};
  reports.forEach(r => { reportMap[`${r.year}-${r.month}`] = r; });

  const years = [currentYear, currentYear - 1];

  function handleClick(year, month) {
    navigate(`/expenses/edit/${year}/${month}`);
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f7f8fa', padding: '32px 24px' }}>
      <div style={{ maxWidth: 940, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28 }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1a1a1a' }}>Monthly Expense Reports</h1>
            <div style={{ color: '#888', fontSize: 13, marginTop: 4 }}>Select a month to view or edit</div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {years.map(y => (
              <button
                key={y}
                onClick={() => setSelectedYear(y)}
                style={{
                  padding: '6px 16px', borderRadius: 20, border: 'none', cursor: 'pointer',
                  background: selectedYear === y ? '#2e7d32' : '#eee',
                  color: selectedYear === y ? '#fff' : '#555',
                  fontWeight: selectedYear === y ? 700 : 400,
                  fontSize: 13, transition: 'background 0.15s',
                }}
              >{y}</button>
            ))}
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#aaa' }}>Loading…</div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
            gap: 16,
          }}>
            {MONTHS.map((_, idx) => {
              const month = idx + 1;
              const key = `${selectedYear}-${month}`;
              return (
                <MonthCard
                  key={key}
                  year={selectedYear}
                  month={month}
                  report={reportMap[key] || null}
                  onClick={handleClick}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
